import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Row, Col, Card, Container, ListGroup, Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { setUploadFile } from '../../../actions/scenarioFileUpload/uploadFile';

import UploadProgress from './uploadProgress/uploadProgress';
import UtilityFormModal from './modal/utilityFormModal';
// import Message from '../../../utilityComponents/Message';
var checkValidFile = true

const ScenarioFileUpload = props => {
    const [ isOpen, setIsOPen ] = useState(false);
    const [ fileSystem, setFileSystem ] = useState('s3-filesystem');
    // const [ message, setMessage ] = useState('');

    function isNum(val){
        return !isNaN(val)
      }
    const handleAttachFile = e => {
        e.preventDefault()
        let text
        let sc_name
        const uploadInput = document.getElementById('close-loop-upload-files');
        console.log(uploadInput)
        text = uploadInput.files[0].name
        for (let i = 0; i < uploadInput.files.length; i++){
            sc_name = uploadInput.files[i].name
            console.log(sc_name)
            console.log(sc_name.startsWith("SC_ADHWY"))
            let var_name
            var_name = sc_name.split(".")[0]
            if(sc_name.startsWith("SC_ADHWY")){
                if(var_name.includes("Var")){
                    let var_numer
                    var_numer = var_name.split("Var")[1]
                    if(isNum(var_numer)){
                        console.log(var_numer)
                    }
                    else{
                        checkValidFile = false
                    }
                }
                else{
                    checkValidFile = false
                }   
            }  
            else{
                checkValidFile = false

            }
        }
        console.log("checkValidFile",checkValidFile)
        if(checkValidFile === true){
            text = "valid File"
           
            const scenarioDescription = document.getElementById('close-loop-scenario-description');
            const description = scenarioDescription.value;
            const scenarioRepresentation = document.getElementById('close-loop-scenario-representation');
            const imageFile = scenarioRepresentation.files[0];
            // const imageName = imageFile.name;
            // const fileName = uploadInput.files[0].name;
    
            props.setUploadFile(uploadInput.files, fileSystem, description, imageFile)
            uploadInput.value = '' // to clear the current file field
            scenarioDescription.value = '' // to clear the scenario Description
            scenarioRepresentation.value = '' // to clear the current image file field
        }
        else{
            checkValidFile = true
            text = "Invalide File. Please upload file with name SC_ADHWY_'<'scenario category'>'_'<'feature'>'_'<'Variation count'>'.xosc eg. SC_ADHWY_TJP_8b_Var192.xosc"
        }
        document.getElementById("demo").innerHTML = text;
       
        
    }

    const openModal = () => {
        setIsOPen(true);
    }

    const closeModal = () => {
        setIsOPen(false);
    }

    const availableFileSystems = [
        {
            'label': 'Cloud-FileSystem',
            'value': 's3-filesystem'
        },
        {
            'label': 'Local-FileSystem',
            'value': 'local-filesystem'
        }
    ]

    return (
        <>
            <Container className="mt-5">
                <Row>
                    <Col>
                        <Card>
                            <Card.Header className='mb-2' style={{ backgroundColor: '#757AF7' }}>
                                <Row>
                                    <Col md={9} sm={5}>
                                        <h4 style={{ color: "#FFFFFF" }}>Upload Scenario File(s)</h4>
                                    </Col>
                                    <Col md={3} sm={7}>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="sh-utility-component">
                                                    <strong>
                                                        For bulk upload create a
                                                        json file with all the files path in it.

                                                        And upload the same file to
                                                        download sh utility file
                                                    </strong>
                                                </Tooltip>
                                            }
                                        >
                                            <Button
                                                type='button'
                                                style={{
                                                    backgroundColor: '#FFFFFF',
                                                    color: '#757AF7'
                                                }}
                                                onClick={openModal}
                                            >
                                                Download sh utility
                                            </Button>
                                        </OverlayTrigger>
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body>
                                <Form onSubmit={handleAttachFile}>
                                    <Row>
                                        <Col>
                                            <Card>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <h4>File(s) :</h4>
                                                        </Col>
                                                        <Col>
                                                            <input
                                                                type="file"
                                                                multiple
                                                                id="close-loop-upload-files"
                                                                data-testid="close-loop-upload-files"
                                                                required
                                                            />
                                                            <p style={{ color: "#FF0000" }} id="demo"></p>
                                                        </Col>
                                                       
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <h4>File System :</h4>
                                                        </Col>
                                                        <Col>
                                                            <Form.Control
                                                                as='select'
                                                                required
                                                                value={fileSystem}
                                                                onChange={ (e) => setFileSystem(e.target.value) }
                                                            >
                                                                { availableFileSystems.map((item, index) => (
                                                                    <option
                                                                        key={`file-system-${index}`}
                                                                        value={item.value}
                                                                    >
                                                                        { item.label }
                                                                    </option>
                                                                )) }
                                                            </Form.Control>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <h4>Description :</h4>
                                                        </Col>
                                                        <Col>
                                                            <Form.Control
                                                                as='textarea'
                                                                required
                                                                id='close-loop-scenario-description'
                                                                data-testid='close-loop-scenario-description'
                                                            >
                                                            </Form.Control>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <h4>Image File :</h4>
                                                        </Col>
                                                        <Col>
                                                            <input
                                                                type="file"
                                                                id="close-loop-scenario-representation"
                                                                data-testid="close-loop-scenario-representation"
                                                                accept="image/*"
                                                                required
                                                            />
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <Row className='mt-2'>
                                        <Col>
                                            <ListGroup.Item>
                                                <Row>
                                                    <Col className='text-center'>
                                                        <Button
                                                            type='submit'
                                                            data-testid='close-loop-scenario-form'
                                                            style={{
                                                                'backgroundColor': '#757AF7',
                                                                'color': '#FFFFFF'
                                                            }}
                                                        >
                                                            Upload
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </ListGroup.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <UploadProgress />
            {isOpen && (
                <UtilityFormModal
                    isOpen={isOpen}
                    closeModal={closeModal}
                />
            )}
        </>
    )
}

ScenarioFileUpload.propTypes = {
    setUploadFile: PropTypes.func
  }

const mapDispatchToProps = dispatch => ({
    setUploadFile: (files, fileSystem, description, imageFile) => dispatch(
    setUploadFile(files, fileSystem, description, imageFile)),
})

export default connect(undefined, mapDispatchToProps)(ScenarioFileUpload);